<style lang="scss" scoped>
.gift-card {
  width: 100%;
  cursor: pointer;
  transition: box-shadow 0.3s;
  margin-bottom: 20px;

  &:hover {
    box-shadow: 0 0 5px 4px #666;
  }
}

// width = fraction - (spaces * margin / columns)
@media (min-width: 576px) and (max-width: 767.98px) {
  .gift-card {
    width: calc(50% - 10px);

    &:nth-child(odd) {
      margin-right: 20px;
    }
  }
}

@media (min-width: 768px) and (max-width: 991.98px) {
  .gift-card {
    width: calc(33.333% - (2 * 20px / 3));

    &:not(:nth-child(3n)) {
      margin-right: 20px;
    }
  }
}

@media (min-width: 992px) and (max-width: 1199.98px) {
  .gift-card {
    width: calc(25% - (3 * 20px / 4));

    &:not(:nth-child(4n)) {
      margin-right: 20px;
    }
  }
}

@media (min-width: 1200px) {
  .gift-card {
    width: calc(20% - (4 * 20px / 5));

    &:not(:nth-child(5n)) {
      margin-right: 20px;
    }
  }
}
</style>

<template>
  <div class="card">
    <div v-if="working" class="card-body p">
      <div class="d-flex justify-content-around">
        <i class="fas fa-spinner fa-spin fa-10x"></i>
      </div>
    </div>
    <div v-else class="card-body p-0">
      <ul class="list-group list-group-flush">
        <li
          class="list-group-item p-3"
          v-for="giftCategory in giftCategories"
          :key="giftCategory.id"
        >
          <h5 class="mb-3">{{ giftCategory.name }}</h5>
          <div class="d-flex flex-wrap align-items-start">
            <div
              v-for="(gift, index) in giftCategory.gifts"
              :key="gift.id"
              @click="$emit('send-gift', gift.id) && $modal.hide(modalName)"
              class="card gift-card"
            >
              <img
                class="card-img-top"
                :src="`/api/v1/gift/${gift.id}`"
                :key="index"
              />
              <div class="card-body">
                <h5 class="card-title text-center">{{ gift.title }}</h5>
                <p class="card-text text-center text-muted">
                  {{ gift.price }} {{ currency }}
                </p>
              </div>
            </div>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
export default {
  props: ["name"],
  data() {
    return {
      giftCategories: [],
      search: "",
      working: true,
      modalName: "gift"
    };
  },
  created() {
    if (this.name) {
      this.modalName = this.name;
    }

    this.queryGiftCategories();
  },
  methods: {
    queryGiftCategories() {
      this.working = true;
      this.$http
        .get("/api/v1/giftCategory?show-default=true", {
          params: {
            filter: [
              { name: "with", value: ["gifts"] },
              { name: "where", attributes: { active: true } }
            ]
          }
        })
        .then(({ data }) => {
          this.giftCategories = data;
        })
        .finally(() => {
          this.working = false;
        });
    }
  },
  computed: {
    currency() {
      return Laravel.lang.currency;
    }
  }
};
</script>
